import { SupportContact } from '@pu/models';

export type SendMessageReq = SupportContact;
